// AD-2698 (Maria, 14 October 2026): nobody can see anything in a report that they cannot see in the profiles. Each
// report detail belongs to the profile section that shows it, and is offered only where the person's role can view
// that section in Manage Access for students, applicants or enquiries. The server makes the same check.

export const REPORT_ACCESS_LINE =
    'You can only report on information your role has permission to view.';

const STUDENT_FIELD_SECTIONS = {
    LegalName: 'Profile',
PreferredName: 'Profile',
ProfileStatus: 'Profile',
Sex: 'Profile',
BoarderStatus: 'Profile',
    SchoolGroups: 'Profile',
YearGroup: 'Profile',
Form: 'Profile',
House: 'Profile',
IntakeGroup: 'Profile',
    ApplicationStatus: 'Profile',
Upn: 'Profile',
PreviousSchoolName: 'Profile',
PreviousSchoolEmail: 'Profile',
    DateOfBirth: 'Profile',
Address: 'Profile',
Postcode: 'Profile',
    ParentContact1: 'Contacts',
ParentContact2: 'Contacts',
    OtcMedicine: 'MedicalConsents',
    SenStatus: 'SEN',
Sen: 'SEN',
    DietaryRequirements: 'DietaryNeedsAndFoodAllergies',
    Welfare: 'Welfare',
    FreeSchoolMeals: 'FreeSchoolMealsEligibility',
    Ethnicity: 'Ethnicity',
FirstLanguageExposedTo: 'Ethnicity',
SpeaksEnglish: 'Ethnicity',
BirthCountry: 'Ethnicity',
    Religion: 'Ethnicity',
LanguageSpokenAtHome: 'Ethnicity',
AsylumStatus: 'Ethnicity',
Nationality: 'Ethnicity',
    Consents: 'Consents',
    TravelOptions: 'TravelMode',
    AdmissionCategories: 'AdmissionCategories',
    MedicalConditions: 'MedicalConditions',
};

const EMPLOYEE_FIELD_SECTIONS = {
    LegalName: 'StaffBasicInformation',
PreferredName: 'StaffBasicInformation',
Title: 'StaffBasicInformation',
    DateOfBirth: 'StaffBasicInformation',
Email: 'StaffBasicInformation',
MobileNumber: 'StaffBasicInformation',
    NINumber: 'StaffIdentificationAndBanking',
BankDetails: 'StaffIdentificationAndBanking',
    HomeAddress: 'StaffHomeAddress',
Postcode: 'StaffHomeAddress',
    CarDetails: 'StaffCars',
NextOfKin: 'StaffNextOfKin',
Contacts: 'StaffContacts',
};

const canView = (permissions = [], module) => permissions.includes(`Permission.${module}.View`);

export const canViewStudentField = (permissions, field) => {
    const section = STUDENT_FIELD_SECTIONS[field];
    return Boolean(section) && ['Student', 'Applicant', 'Enquiry'].some(kind => canView(permissions, `${kind}${section}`));
};

export const canViewEmployeeField = (permissions, field) => {
    const section = EMPLOYEE_FIELD_SECTIONS[field];
    return Boolean(section) && canView(permissions, section);
};

export const canRunMedicineAtSchoolReport = permissions => canView(permissions, 'StudentMedicines');

export const canRunMedicalEventsReport = permissions =>
    canView(permissions, 'StudentMedicalEvents') || canView(permissions, 'ApplicantMedicalEvents');
